<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
/deep/.el-table-column--selection .cell{padding-right: 10px;}
/deep/.el-form-item__content .el-input {width: 400px;}
/deep/.el-form-item__label {width: 10%;margin-left: 100px;}
/deep/.el-form-item__content img {width: 148px;height: 148px;}
</style>

<template>
  <!--列表-->
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="title" label="证书标题"></el-table-column>
        <el-table-column prop="content" label="内容"> </el-table-column>
        <el-table-column label="证书图片">
          <template slot-scope="scope">
            <img :src="scope.row.thumb" width="100px" height="80px" class="head_pic"/>
          </template>
        </el-table-column>
        <el-table-column prop="authority" label="发证机构"></el-table-column>
        <el-table-column label="发证日期" width="180">
          <template slot-scope="scope">{{ (scope.row.fromtime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column label="到期日期" width="180">
           <template slot-scope="scope">{{ (scope.row.totime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
            <el-button type="danger" @click="deletefn(11, 47, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="btnbox">
        <el-button type="success" @click="addfn2()" class="elbtn">添加</el-button>
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 47)">批量删除</el-button>
      </div>
    </div>
    <!-- 修改弹框 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="dialogVisible"
      :width="widthCSH"
      title="修改荣誉资质"
      class="mydialog">
      <QyzsRyzzUpdata :ryzzID='ryzzID' @cancle="cancle" @getList="getList"></QyzsRyzzUpdata>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import QyzsRyzzUpdata from '../QyxxUpdate/QyzsRyzzUpdata.vue'
import filters from '../../../method/filter'
import '../../../../backer/method/dialog'
export default {
  mixins: [filters],
  props: ['companyName'],
  components: {
    QyzsRyzzUpdata
  },
  data()
  {
    return {
      ryzzID: null,
      //列表数据
      tableData: [],
      //弹框显隐
      dialogVisible: false,
      widthCSH: '75%',
      // 多删id数组
      multipleSelection: []
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '2')
          this.getList()
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      if (!window.userData.company) return
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 26,
        _exp: `company = '${window.userData.company}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 47,
          _exp: `companyid = '${ret[0].id}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          let temp = []
          ret.forEach((item) =>
          {
            temp.push({
              id: item.id,
              title: item.title,
              content: item.content,
              thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
              authority: item.authority,
              fromtime: item.fromtime,
              totime: item.totime
            })
            this.tableData = temp
          })
        })
      })
    },
    //点击修改
    updatafn(row)
    {
      this.ryzzID = row.id
      this.dialogVisible = true
    },
    cancle()
    {
      this.dialogVisible = false
      this.getList()
    },
    addfn2()
    {
      this.$emit('addTab2')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/qyxx/QyxxLB/QyzsRyzzLB.vue